import type { CSSProperties, MouseEventHandler } from "react";
import "./GoogleLoginButton.css";
import { OnflyLoading } from "../../tools/OnflyLoading";

interface GoogleIconProps {
  size?: number;
}

const GoogleIcon = ({ size = 18 }: GoogleIconProps) => (
  <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden>
    <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.92a8.78 8.78 0 0 0 2.68-6.61z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
    <path fill="#FBBC05" d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.3-1.72V4.95H.96A9 9 0 0 0 0 9c0 1.45.35 2.82.96 4.04l3.01-2.32z" />
    <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
  </svg>
);

interface GoogleLoginButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
  label?: string;
  loadingLabel?: string;
  className?: string;
  style?: CSSProperties;
}

const GoogleLoginButton = ({
  onClick,
  loading = false,
  label = "Continuar com Google",
  loadingLabel = "Conectando...",
  className = "",
  style,
}: GoogleLoginButtonProps) => {
  return (
    <button
      type="button"
      className={`gg-google-btn ${className}`.trim()}
      style={style}
      onClick={onClick}
      disabled={loading}
    >
      {loading ? (
        <>
          <OnflyLoading containerSize={30} />
          {loadingLabel}
        </>
      ) : (
        <>
          <GoogleIcon />
          {label}
        </>
      )}
    </button>
  );
};

export default GoogleLoginButton;
